export default "__VITE_ASSET__DX$8_lkb__"